export const getFilterCondition = (path) => {
  const checkFirstPart = (fl, key) =>
    fl.FormKey.split('-')[0] === key;

  switch (path) {
    case '/Login':
      return (fl) =>
        fl.FormKey.includes('login') ||
        fl.FormKey.includes('general');
    case '/':
      return (fl) =>
        fl.FormKey.includes('login') ||
        fl.FormKey.includes('general');
    default:
      return (fl) => fl;
  }
};

// !['general', 'login'].some((key) =>
//   checkFirstPart(fl, key)
// );
